export default "errorPage/SET_FETCH_ERROR";
